import React, { useEffect } from "react";
import { LoggedInView } from "../common/LoggedInView";
import { Link, useParams } from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import { getClientContacts } from "../../store/reducers/ClientContactsSlice";
import {ClientContactsTable} from "./components/ClientContactsTable";
import {getCurrentClient} from "../../store/reducers/ClientsSlice";

interface ClientContactsScreenProps {}

export const ClientContactsScreen: React.FC<ClientContactsScreenProps> = () => {

    const dispatch = useAppDispatch();
    const { clientId } = useParams<{ clientId: string }>();

    const clientsState = useAppSelector((state) => state.clients);

    useEffect(() => {
        if (clientId) {
            dispatch(getCurrentClient({ id: clientId }));
            dispatch(getClientContacts({ clientId: parseInt(clientId, 10) })); // Parse clientId if it exists
        }
    }, [clientId]);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Kliendi {clientsState?.currentClient?.name} kontaktisikud</h1>
            <ClientContactsTable clientId={String(clientId)} />
            <ul className="table-actions">
                <li><Link to={`/clients/${clientId}/contacts/new`}><strong>Lisa
                    kontakt</strong></Link></li>
            </ul>
        </LoggedInView>
    );
};